/* eslint-disable react/jsx-pascal-case */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
import {
  SignIn,
  Verify_User_Device,
  // SignUp, // Assuming you have a SignUp action
} from "../../ReduxStore/Slice/Auth/AuthSlice";
import Modal from "../../Components/ExtraComponents/Modal";
import OtpInput from "react-otp-input";
import { check_Device } from "../../Utils/find_device";
import { getLastFourDigits } from "../../Utils/common_Functions";
import toast from "react-hot-toast";
import $ from "jquery";
import ToastButton from "../../Components/ExtraComponents/Alert_Toast";

import { useFormik } from "formik";
import * as Yup from "yup";

import { Get_Company_Logo } from "../../ReduxStore/Slice/Admin/AdminSlice";
import { GET_IP } from "../../Service/common.service";
import {
  UPDATE_DATEFILTER_PERMISSION,
  GET_DATEFILTR,
} from "../../ReduxStore/Slice/Admin/AdminHelpSlice";

const LoginFull = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [CheckUser, setCheckUser] = useState(check_Device());
  const [showModal, setshowModal] = useState(false);
  const [typeOtp, setTypeOtp] = useState("");
  const [UserData, setUserData] = useState("");
  const [signInBtn, setSignInBtn] = useState(false);
  const [registerBtn, setRegisterBtn] = useState(false);
  const [ip, setIp] = useState("");
  const canvasRef = useRef(null);
  const [pageStatus, setPageStatus] = useState("login");
  // New state for logo and company name
  const [companyLogo, setCompanyLogo] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [themeName, setThemeName] = useState("");
  const [favicon, setFavicon] = useState("");
  const [dateFilterPermission, setDateFilterPermission] = useState("0");
  const token = localStorage.getItem("token");

  console.log("Theme Name:", dateFilterPermission);



  useEffect(() => {
    GET_IP().then((response) => {
      setIp(response.data.ip);
    });
  }, []);

  // Optimized Canvas Animation
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    let animationFrameId;

    const setCanvasSize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };

    window.addEventListener("resize", setCanvasSize);
    setCanvasSize();

    // Reduce particle count for performance
    const particles = [];
    const numParticles = 30;
    const maxDistance = 100;

    class Particle {
      constructor(x, y) {
        this.x = x;
        this.y = y;
        this.vx = (Math.random() - 0.5) * 0.4;
        this.vy = (Math.random() - 0.5) * 0.4;
        this.radius = Math.random() * 1.2 + 0.5;
      }
      update() {
        this.x += this.vx;
        this.y += this.vy;
        if (this.x < 0 || this.x > canvas.width) this.vx *= -1;
        if (this.y < 0 || this.y > canvas.height) this.vy *= -1;
      }
      draw(particleColor) {
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
        ctx.fillStyle = particleColor;
        ctx.fill();
      }
    }

    for (let i = 0; i < numParticles; i++) {
      particles.push(
        new Particle(
          Math.random() * canvas.width,
          Math.random() * canvas.height
        )
      );
    }

    // Only check nearby particles for lines (skip O(n²) loop)
    const animate = () => {
      const styles = getComputedStyle(document.body);
      const bgColor = styles.getPropertyValue("--login-bg") || "#fff";
      const particleColor = styles.getPropertyValue("--particle-color") || "rgba(0,0,0,0.5)";
      const lineColor = styles.getPropertyValue("--line-color") || "rgba(0,0,0,0.3)";

      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.fillStyle = bgColor;
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      for (let i = 0; i < particles.length; i++) {
        particles[i].update();
        particles[i].draw(particleColor);
        // Only check next 5 particles for lines
        for (let j = i + 1; j < Math.min(i + 6, particles.length); j++) {
          const p1 = particles[i];
          const p2 = particles[j];
          const dx = p1.x - p2.x;
          const dy = p1.y - p2.y;
          const distance = Math.sqrt(dx * dx + dy * dy);
          if (distance < maxDistance) {
            ctx.beginPath();
            ctx.moveTo(p1.x, p1.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.strokeStyle = lineColor;
            ctx.globalAlpha = 0.3 - (distance / maxDistance) * 0.2;
            ctx.lineWidth = 0.5;
            ctx.stroke();
            ctx.globalAlpha = 1;
          }
        }
      }
      animationFrameId = requestAnimationFrame(animate);
    };
    animate();
    return () => {
      window.removeEventListener("resize", setCanvasSize);
      cancelAnimationFrame(animationFrameId);
    };
  }, []);

  const updateDateFilterPermissionHandler = async (value) => {
    try {
      const res = await dispatch(
        UPDATE_DATEFILTER_PERMISSION({
          Datefilterpermission: Number(value),
          token,
        })
      ).unwrap();

      if (res.status) {
        setDateFilterPermission(value);

        // ✅ localStorage me save
        localStorage.setItem(
          "dateFilterPermission",
          String(value)
        );
      }
    } catch {
      toast.error("Failed to Update Date Filter Permission");
    }
  };

  // useEffect(() => {
  //   updateDateFilterPermissionHandler(dateFilterPermission);
  // }, []);


  useEffect(() => {
    const fetchDateFilterPermission = async () => {
      try {
        const res = await dispatch(GET_DATEFILTR(token)).unwrap();
     
        if (res.status && res.data.length > 0) {
          const value = String(res.data[0].Datefilterpermission);
          setDateFilterPermission(value);
          localStorage.setItem("dateFilterPermission", value);
        }
      } catch (err) {
        toast.error("Failed to fetch Date Filter Permission");
      }
    };

    if (token) {
      fetchDateFilterPermission();
    }
  }, [dispatch, token]);


 


  useEffect(() => {
    const savedPermission = localStorage.getItem("dateFilterPermission");
    if (savedPermission !== null) {
      setDateFilterPermission(savedPermission);
    }
  }, []);



  const CompanyName = async () => {
    await dispatch(Get_Company_Logo())
      .unwrap()
      .then((response) => {
        if (response.status && response.data && response.data[0]) {
          setCompanyLogo(response.data[0].logo);
          setCompanyName(response.data[0].panel_name);
          setThemeName(response.data[0].theme_name);
          setFavicon(response.data[0].favicon);
          // Set theme class on body
          document.body.className = response.data[0].theme_name;
          // Set favicon
          let fav = document.querySelector("link[rel='icon']");
          if (!fav) {
            fav = document.createElement("link");
            fav.rel = "icon";
            fav.type = "image/x-icon";
            document.head.appendChild(fav);
          }
          fav.href = response.data[0].favicon;

          localStorage.setItem("theme", response.data[0].theme_name);
          localStorage.setItem("landing_page_permission", response.data[0].landing_page_permission);
          // localStorage.setItem("panel_name", response.data[0].panel_name);
        }
      })
      .catch((error) => {
        return;
      });
  };

  useEffect(() => {
    CompanyName();
  }, []);

  // Login Formik Configuration
  const loginFormik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object().shape({
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      password: Yup.string()
        .min(4, "Password must be at least 4 characters")
        .required("Password is required"),
    }),
    onSubmit: async (values) => {
      setSignInBtn(true);
      let req = {
        Email: values.email,
        Password: values.password,
        device: CheckUser,
        network_ip: ip,
      };
      await dispatch(SignIn(req))
        .unwrap()
        .then(async (response) => {
          if (response.status) {
            setSignInBtn(false);
            if (response.data.Role !== "SUPERADMIN") {
              setshowModal(true);
              setUserData(response.data);
            } else if (response.data.Role === "SUPERADMIN") {

              localStorage.setItem(
                "user_details",
                JSON.stringify(response.data)
              );
              localStorage.setItem(
                "user_role",
                JSON.stringify(response.data.Role)
              );
              setTimeout(() => {
                navigate("/super/dashboard");
              }, 1000);
            }
          } else {
            toast.error(response.msg);
            setSignInBtn(false);
          }
        })
        .catch((error) => {
          setSignInBtn(false);
        });
    },
  });

  // Registration Formik Configuration
  const registerFormik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      password: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object().shape({
      firstName: Yup.string()
        .min(2, "First name must be at least 2 characters")
        .max(50, "First name must be less than 50 characters")
        .required("First name is required"),
      lastName: Yup.string()
        .min(2, "Last name must be at least 2 characters")
        .max(50, "Last name must be less than 50 characters")
        .required("Last name is required"),
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      phoneNumber: Yup.string()
        .matches(/^[0-9]{10}$/, "Phone number must be 10 digits")
        .required("Phone number is required"),
      password: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .max(20, "Password must be less than 20 characters")
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/,
          "Password must contain at least one uppercase letter, one lowercase letter, and one number"
        )
        .required("Password is required"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("password"), null], "Passwords must match")
        .required("Confirm password is required"),
    }),
    onSubmit: async (values) => {
      setRegisterBtn(true);
      let req = {
        FirstName: values.firstName,
        LastName: values.lastName,
        Email: values.email,
        PhoneNumber: values.phoneNumber,
        Password: values.password,
        device: CheckUser,
        network_ip: ip,
      };

      // Assuming you have a SignUp action in your Redux slice
      // try {
      //   const response = await dispatch(SignUp(req)).unwrap();
      //   if (response.status) {
      //     toast.success(response.msg || "Registration successful!");
      //     setPageStatus("login"); // Switch back to login form
      //     registerFormik.resetForm();
      //   } else {
      //     toast.error(response.msg || "Registration failed");
      //   }
      // } catch (error) {
      //   toast.error(error.message || "Registration failed");
      // } finally {
      //   setRegisterBtn(false);
      // }
    },
  });

  const verifyOTP = async () => {
    setSignInBtn(true);
    if (typeOtp === "" || typeOtp.length < 4) {
      Swal.fire("Invalid OTP", "Please enter a valid 4-digit OTP.", "warning");
      setSignInBtn(false);
      return;
    }
    let req = {
      Email: UserData.Email,
      Device: CheckUser,
      Otp: typeOtp,
      network_ip: ip,
    };
    await dispatch(Verify_User_Device(req))
      .unwrap()
      .then((res) => {
        if (res.firstlogin === "0") {
          setSignInBtn(false);
        } else {
          if (res.status) {
            const roles = ["ADMIN", "USER", "SUBADMIN", "SUPERADMIN"];
            const userData = UserData;
            const role = userData && userData.Role;
            const mobileNo = getLastFourDigits(
              userData && userData.mobile,
              typeOtp
            );
            if (roles.includes(role) && mobileNo === true) {
              setSignInBtn(false);
              localStorage.setItem("user_details", JSON.stringify(userData));
              localStorage.setItem("user_role", JSON.stringify(role));

              localStorage.setItem("selectedAvatar", userData?.profileimg);
              localStorage.setItem("backtestPermission", userData?.backtestPermission);


              // Swal.fire("Logged In", "Logged in", "success");

              let redirectPath = `/${role === "USER"
                ? "client/dashboard"
                : role === "SUBADMIN"
                  ? "subadmin/dashboard"
                  : role === "ADMIN"
                    ? "admin/dashboard"
                    : role === "SUPERADMIN"
                      ? "/super/dashboard"
                      : ""
                }`;
              setshowModal(false);
              navigate(redirectPath);
              toast.success("Login Successful");

            } else {
              toast.error(mobileNo);
              setSignInBtn(false);
            }
          } else {
            if (
              res.msg === "You are already logged in on the Web." ||
              res.msg === "You are already logged in on the phone."
            ) {
              toast.error(res.msg);
              setshowModal(false);
              setSignInBtn(false);
            } else {
              toast.error(res.msg);
              setTimeout(() => {
                setSignInBtn(false);
              }, 1000);
            }
          }
        }
      })
      .catch((error) => { });
  };

  useEffect(() => {
    CompanyName();
    // Only set device once at mount
    setCheckUser(check_Device());
  }, []);


  return (
    <div className="modern-auth-wrapper">
      <div className="auth-container">
        {/* Left Side - Branding */}
        <div className="auth-brand-section">
          <canvas ref={canvasRef} className="background-canvas"></canvas>
          {/* Floating Elements */}
          <div className="floating-elements">
            <div className="float-element float-1"></div>
            <div className="float-element float-2"></div>
            <div className="float-element float-3"></div>
          </div>
          <div className="brand-content">
            <div className="brand-logo-container">
              <img className="logo-abbr" src={companyLogo} alt="logo" />
            </div>
            <div className="Company_logo" style={{ fontWeight: 600, fontSize: '1.2rem', marginBottom: '0.5rem' }}>{companyName}</div>
            <p className="brand-subtitle">
              {pageStatus === "login"
                ? "Welcome back! Please sign in to your account"
                : "Create your account and start your journey with us"}
            </p>
            <div className="feature-list">
              <div className="feature-item">
                <i className="fas fa-shield-alt"></i>
                <span>Secure & Protected</span>
              </div>
              <div className="feature-item">
                <i className="fas fa-bolt"></i>
                <span>Fast & Reliable</span>
              </div>
              <div className="feature-item">
                <i className="fas fa-chart-line"></i>
                <span>Advanced Analytics</span>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side - Form */}
        <div className="auth-form-section">
          <div className="form-container">
            <div className="form-header">
              <h2 className="form-title">
                {pageStatus === "login" ? "Sign In" : "Create Account"}
              </h2>
              <p className="form-subtitle">
                {pageStatus === "login"
                  ? "Enter your credentials to access your account"
                  : "Fill in your information to get started"}
              </p>
            </div>

            {pageStatus === "register" ? (
              <RegisterForm
                formik={registerFormik}
                registerBtn={registerBtn}
                setPageStatus={setPageStatus}
              />
            ) : (
              <LoginForm
                formik={loginFormik}
                signInBtn={signInBtn}
                setPageStatus={setPageStatus}
              />
            )}

            {pageStatus === "login" && (
              <div className="form-footer">
                <Link to="/forget" className="forgot-password-link">
                  <i className="fas fa-key"></i>
                  Forgot Password?
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>

      {showModal && (
        <Modal
          isOpen={showModal}
          handleClose={() => setshowModal(false)}
          backdrop="static"
          size="md"
          title="Verify OTP"
          btn_name="Verify"
          Submit_Function={verifyOTP}
          disabled_submit={signInBtn}
        >
          <form
            id="otp-form"
            onSubmit={(e) => {
              e.preventDefault();
              verifyOTP();
            }}
            autoComplete="off"
          >
            <div className="otp-container">
              <div className="otp-header">
                <i className="fas fa-mobile-alt otp-icon"></i>
                <h4>Verification Required</h4>
                <p>Enter the last 4 digits of your phone number</p>
              </div>

              <OtpInput
                containerStyle="modern-otp-container"
                value={typeOtp}
                onChange={setTypeOtp}
                numInputs={4}
                renderSeparator={<span className="otp-separator"></span>}
                renderInput={(props, index) => (
                  <input
                    {...props}
                    type="number"
                    inputMode="numeric"
                    pattern="\d*"
                    autoFocus={index === 0}
                    autoComplete="off"
                    name={`otp-field-${index}`}
                    className="modern-otp-input"
                  />
                )}
              />
            </div>
          </form>
        </Modal>
      )}

      <ToastButton />

      <style>{`
        .modern-auth-wrapper {
          height: 100vh;
          position: relative;
          overflow: auto;
        }

        .modern-submit-btn::before {
          content: "";
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(
            90deg,
            transparent,
            rgba(255, 255, 255, 0.2),
            transparent
          );
          transition: left 0.5s ease;
        }

        .modern-submit-btn:hover::before {
          left: 100%;
        }

        .modern-submit-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 25px -5px rgba(99, 102, 241, 0.4);
        }

        .modern-submit-btn:disabled {
          opacity: 0.7;
          cursor: not-allowed;
          transform: none;
        }

        .modern-spinner {
          width: 20px;
          height: 20px;
          border: 2px solid rgba(255, 255, 255, 0.3);
          border-top: 2px solid white;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }

        .form-switch-text {
          text-align: center;
          margin-top: 2rem;
          font-size: 0.9rem;
          color: #64748b;
        }

        .form-switch-btn {
          background: none;
          border: none;
          color: #6366f1;
          font-weight: 600;
          cursor: pointer;
          text-decoration: none;
          margin-left: 0.5rem;
          transition: all 0.2s ease;
        }

        .form-switch-btn:hover {
          color: #4f46e5;
          text-decoration: underline;
        }

        .form-footer {
          text-align: center;
          margin-top: 2rem;
        }

        .forgot-password-link {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          color: #6366f1;
          text-decoration: none;
          font-size: 0.9rem;
          font-weight: 500;
          transition: all 0.2s ease;
        }

        .forgot-password-link:hover {
          color: #4f46e5;
          transform: translateY(-1px);
        }

        .forgot-password-link i {
          font-size: 0.8rem;
        }

        /* OTP Styles */
        .otp-container {
          text-align: center;
        }

        .otp-header {
          margin-bottom: 2rem;
        }

        .otp-icon {
          width: 60px;
          height: 60px;
          background: var(--btn-background);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 1.5rem;
          margin: 0 auto 1rem;
        }

        .otp-header h4 {
          // color: #1e293b;
          font-size: 1.25rem;
          font-weight: 600;
          margin-bottom: 0.5rem;
        }

        .otp-header p {
          color: #64748b;
          font-size: 0.9rem;
        }

        .modern-otp-container {
          display: flex;
          justify-content: center;
          gap: 0.5rem;
          margin: 2rem 0;
        }

        .modern-otp-input {
          width: 50px !important;
          height: 50px;
          border: 2px solid #e5e7eb;
          border-radius: 12px;
          text-align: center;
          font-size: 1.2rem;
          font-weight: 600;
          color: #1e293b;
          transition: all 0.2s ease;
          background: rgba(255, 255, 255, 0.8);
        }

        .modern-otp-input:focus {
          outline: none;
          border-color: #6366f1;
          box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
          background: rgba(255, 255, 255, 0.95);
        }

        .otp-separator {
          width: 10px;
        }

        /* Form Row Styles */
        .form-row {
          display: flex;
          gap: 1rem;
          margin-bottom: 1.5rem;
        }

        .form-row .modern-form-group {
          flex: 1;
          margin-bottom: 0;
        }

        /* Responsive Design */
        @media (max-width: 1024px) {
          .auth-container {
            flex-direction: column;
            height: auto;
            min-height: 100vh;
          }

          .auth-brand-section {
            flex: none;
            padding: 2rem;
          }

          .brand-title {
            font-size: 2rem;
          }

          .feature-list {
            flex-direction: row;
            justify-content: center;
            gap: 2rem;
          }
        }

        @media (max-width: 768px) {
          .auth-container {
           
            border-radius: 16px;
          }

          .auth-brand-section,
          .auth-form-section {
            padding: 1.5rem;
          }

          .form-row {
            flex-direction: column;
            gap: 0;
          }

          .form-row .modern-form-group {
            margin-bottom: 1.5rem;
          }

          .feature-list {
            flex-direction: column;
            gap: 1rem;
          }

          .modern-otp-container {
            gap: 0.5rem;
          }

          .modern-otp-input {
            width: 45px;
            height: 45px;
            font-size: 1.1rem;
          }
        }

        @media (max-width: 480px) {
          // .modern-auth-wrapper {
          //   padding: 0.5rem;
          // }

          .auth-container {
            margin: 0;
            border-radius: 12px;
          }

          .form-title {
            font-size: 1.75rem;
          }

          .brand-title {
            font-size: 1.75rem;
          }

          .modern-otp-input {
            width: 40px;
            height: 40px;
            font-size: 1rem;
          }
        }
      `}</style>
    </div>
  );
};

// Login Form Component
function LoginForm({ formik, signInBtn, setPageStatus }) {
  const [passwordVisible, setPasswordVisible] = useState(false);

  return (
    <div>
      <form onSubmit={formik.handleSubmit} className="w-100">
        <div className="modern-form-group">
          <label htmlFor="email" className="modern-form-label">
            Email Address
          </label>
          <div className="modern-input-container">
            <input
              type="email"
              id="email"
              name="email"
              placeholder="Enter your email"
              className="modern-form-input"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.email}
              autoComplete="email"
            />
            <i className="fas fa-envelope modern-input-icon"></i>
          </div>
          {formik.touched.email && formik.errors.email ? (
            <div className="modern-error-message">{formik.errors.email}</div>
          ) : null}
        </div>

        <div className="modern-form-group">
          <label htmlFor="password" className="modern-form-label">
            Password
          </label>
          <div className="modern-input-container">
            <input
              type={passwordVisible ? "text" : "password"}
              id="password"
              name="password"
              placeholder="Enter your password"
              className="modern-form-input"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.password}
              autoComplete="current-password"
            />
            <i className="fas fa-lock modern-input-icon"></i>
            <i
              className={`fas ${passwordVisible ? "fa-eye-slash" : "fa-eye"
                } modern-eye-icon`}
              onClick={() => setPasswordVisible(!passwordVisible)}
            ></i>
          </div>
          {formik.touched.password && formik.errors.password ? (
            <div className="modern-error-message">{formik.errors.password}</div>
          ) : null}
        </div>

        <button
          type="submit"
          className="modern-submit-btn"
          disabled={signInBtn || !formik.isValid || !formik.dirty}
        >
          {signInBtn ? (
            <>
              <div className="modern-spinner"></div>
              <span>Signing In...</span>
            </>
          ) : (
            <>
              <i className="fas fa-sign-in-alt"></i>
              <span>Sign In</span>
            </>
          )}
        </button>
      </form>

      {/* <div className="form-switch-text">
        Don't have an account?
        <button
          type="button"
          className="form-switch-btn"
          onClick={() => setPageStatus("register")}
        >
          Create Account
        </button>
      </div> */}
    </div>
  );
}

// Registration Form Component
function RegisterForm({ formik, registerBtn, setPageStatus }) {
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);

  return (
    <div>
      <form onSubmit={formik.handleSubmit} className="w-100">
        {/* Name Row */}
        <div className="form-row">
          <div className="modern-form-group">
            <label htmlFor="firstName" className="modern-form-label">
              First Name
            </label>
            <div className="modern-input-container">
              <input
                type="text"
                id="firstName"
                name="firstName"
                placeholder="First name"
                className="modern-form-input"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.firstName}
                autoComplete="given-name"
              />
              <i className="fas fa-user modern-input-icon"></i>
            </div>
            {formik.touched.firstName && formik.errors.firstName ? (
              <div className="modern-error-message">
                {formik.errors.firstName}
              </div>
            ) : null}
          </div>

          <div className="modern-form-group">
            <label htmlFor="lastName" className="modern-form-label">
              Last Name
            </label>
            <div className="modern-input-container">
              <input
                type="text"
                id="lastName"
                name="lastName"
                placeholder="Last name"
                className="modern-form-input"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.lastName}
                autoComplete="family-name"
              />
              <i className="fas fa-user modern-input-icon"></i>
            </div>
            {formik.touched.lastName && formik.errors.lastName ? (
              <div className="modern-error-message">
                {formik.errors.lastName}
              </div>
            ) : null}
          </div>
        </div>

        {/* Email & Phone Row */}
        <div className="form-row">
          <div className="modern-form-group">
            <label htmlFor="register-email" className="modern-form-label">
              Email Address
            </label>
            <div className="modern-input-container">
              <input
                type="email"
                id="register-email"
                name="email"
                placeholder="Email address"
                className="modern-form-input"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.email}
                autoComplete="email"
              />
              <i className="fas fa-envelope modern-input-icon"></i>
            </div>
            {formik.touched.email && formik.errors.email ? (
              <div className="modern-error-message">{formik.errors.email}</div>
            ) : null}
          </div>

          <div className="modern-form-group">
            <label htmlFor="phoneNumber" className="modern-form-label">
              Phone Number
            </label>
            <div className="modern-input-container">
              <input
                type="tel"
                id="phoneNumber"
                name="phoneNumber"
                placeholder="Phone number"
                className="modern-form-input"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.phoneNumber}
                autoComplete="tel"
              />
              <i className="fas fa-phone modern-input-icon"></i>
            </div>
            {formik.touched.phoneNumber && formik.errors.phoneNumber ? (
              <div className="modern-error-message">
                {formik.errors.phoneNumber}
              </div>
            ) : null}
          </div>
        </div>

        {/* Password Row */}
        <div className="form-row">
          <div className="modern-form-group">
            <label htmlFor="register-password" className="modern-form-label">
              Password
            </label>
            <div className="modern-input-container">
              <input
                type={passwordVisible ? "text" : "password"}
                id="register-password"
                name="password"
                placeholder="Create password"
                className="modern-form-input"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.password}
                autoComplete="new-password"
              />
              <i className="fas fa-lock modern-input-icon"></i>
              <i
                className={`fas ${passwordVisible ? "fa-eye-slash" : "fa-eye"
                  } modern-eye-icon`}
                onClick={() => setPasswordVisible(!passwordVisible)}
              ></i>
            </div>
            {formik.touched.password && formik.errors.password ? (
              <div className="modern-error-message">
                {formik.errors.password}
              </div>
            ) : null}
          </div>

          <div className="modern-form-group">
            <label htmlFor="confirmPassword" className="modern-form-label">
              Confirm Password
            </label>
            <div className="modern-input-container">
              <input
                type={confirmPasswordVisible ? "text" : "password"}
                id="confirmPassword"
                name="confirmPassword"
                placeholder="Confirm password"
                className="modern-form-input"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.confirmPassword}
                autoComplete="new-password"
              />
              <i className="fas fa-lock modern-input-icon"></i>
              <i
                className={`fas ${confirmPasswordVisible ? "fa-eye-slash" : "fa-eye"
                  } modern-eye-icon`}
                onClick={() =>
                  setConfirmPasswordVisible(!confirmPasswordVisible)
                }
              ></i>
            </div>
            {formik.touched.confirmPassword && formik.errors.confirmPassword ? (
              <div className="modern-error-message">
                {formik.errors.confirmPassword}
              </div>
            ) : null}
          </div>
        </div>

        <button
          type="submit"
          className="modern-submit-btn"
          disabled={registerBtn || !formik.isValid || !formik.dirty}
        >
          {registerBtn ? (
            <>
              <div className="modern-spinner"></div>
              <span>Creating Account...</span>
            </>
          ) : (
            <>
              <i className="fas fa-user-plus"></i>
              <span>Create Account</span>
            </>
          )}
        </button>
      </form>

      <div className="form-switch-text">
        Already have an account?
        <button
          type="button"
          className="form-switch-btn"
          onClick={() => setPageStatus("login")}
        >
          Sign In
        </button>
      </div>
    </div>
  );
}

export default LoginFull;
